import '@xr/ui/css/admin.css';
import '@xr/ui/css/dirham.css';
import '@xr/ui/css/brand.css';
import '@xr/templates/css/paper.css';
import './app.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { applyPrefs } from './lib/prefs';

applyPrefs();
try { matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => applyPrefs()); } catch { /* old browsers */ }
createRoot(document.getElementById('app')!).render(<StrictMode><App /></StrictMode>);
